import { ValidateAny } from "./ValidateAny";
import { Moment } from "moment";

export class ValidateDate<TRoot> extends ValidateAny<{ startDate: Moment, endDate: Moment }, TRoot> {
    
    constructor(name: string, key: string) {
        super(name, key);

        this.add((value: any, root: TRoot) => {
            if (!value) {
                return null;
            }
            if ((value && !value.isValid()))
                return { message: `${this.name || 'Dit veld'} bevat een ongeldige datum` };

            return null;
        });
    }
}
